module.exports = __webpack_public_path__ + "img/prize-00.5cd9a513.png";